import React from 'react';
import { Grid } from '@mui/material';
import AutocompleteField from '../../../../components/general/fields/autocompleteField';
import FieldText from '../../../../components/general/fields/fieldText';
import { DependencyFormProps } from './types';

export const DependencyForm: React.FC<DependencyFormProps> = ({
    formik,
    questionDependency,
    dependencies,
}) => {
    return (
        <>
            <Grid item xs={6} mt={1}>
                <AutocompleteField
                    data={dependencies}
                    label="Pregunta a depender"
                    name="questionDependency"
                    size="small"
                    required={Boolean(formik.values.dependency)}
                    touched={formik.touched.questionDependency}
                    errors={formik.errors.questionDependency}
                    value={formik.values.questionDependency}
                    onChangeValue={(value) =>
                        formik.setFieldValue('questionDependency', value)
                    }
                    getOptionLabel={(option: any) => option.description || ''}
                />
            </Grid>
            {[
                'multiple',
                'only',
                'linear-label',
                'list-only',
                'validation-reference',
            ].find((type) => type === questionDependency?.type) &&
                questionDependency?.answers &&
                questionDependency?.answers.length > 0 && (
                <Grid item xs={6} mt={1}>
                    <AutocompleteField
                        data={questionDependency?.answers}
                        label="Respuesta a depender"
                        name="answerDependency"
                        size="small"
                        disabled={Boolean(
                            !formik.values.questionDependency
                        )}
                        required={Boolean(formik.values.dependency)}
                        touched={formik.touched.answerDependency}
                        errors={formik.errors.answerDependency}
                        value={formik.values.answerDependency}
                        onChangeValue={(value) =>
                            formik.setFieldValue('answerDependency', value)
                        }
                        getOptionLabel={(option: any) =>
                            (questionDependency?.type === 'linear-label'
                                ? option.label
                                : option.description) || ''
                        }
                    />
                </Grid>
            )}
            {questionDependency?.type === 'linear' && (
                <>
                    <Grid item xs={3} mt={1}>
                        <FieldText
                            label={`Rango a depender (${questionDependency?.answers[0]?.range})`}
                            name="range1"
                            size="small"
                            required={true}
                            touched={formik.touched.range1}
                            errors={formik.errors.range1}
                            value={formik.values.range1}
                            onChange={formik.handleChange}
                        />
                    </Grid>
                    <Grid item xs={3} mt={1}>
                        <FieldText
                            label={`Rango a depender (${questionDependency?.answers[0]?.range})`}
                            name="range2"
                            size="small"
                            required={true}
                            touched={formik.touched.range2}
                            errors={formik.errors.range2}
                            value={formik.values.range2}
                            onChange={formik.handleChange}
                        />
                    </Grid>
                </>
            )}
        </>
    );
};
